import { motion } from "framer-motion";
import { ArrowUpRight, Clock, BookOpen } from "lucide-react";

const POSTS = [
  {
    cat: "Market Insight",
    title: "Why SIP Discipline Wins When Markets Are Volatile",
    excerpt: "A look at how rupee-cost-averaging produces materially better risk-adjusted outcomes across three full market cycles.",
    img: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=900&q=80",
    read: "6 min read",
    date: "Nov 2025",
  },
  {
    cat: "Tax Planning",
    title: "ELSS vs PPF vs NPS: Choosing the Right Section 80C Mix",
    excerpt: "A side-by-side framework to pick the optimal mix of 80C instruments based on age, risk-tolerance and income bracket.",
    img: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=900&q=80",
    read: "9 min read",
    date: "Nov 2025",
  },
  {
    cat: "Wealth Strategy",
    title: "The Quiet Compounding Power of Asset Allocation",
    excerpt: "Why the asset-allocation decision explains over 90% of long-term portfolio outcomes — and how to get it right.",
    img: "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?auto=format&fit=crop&w=900&q=80",
    read: "7 min read",
    date: "Oct 2025",
  },
];

export default function BlogPreview() {
  return (
    <section id="blogs" data-testid="blogs-section" className="section relative bg-[#050505]">
      <div id="resources" className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <p className="text-xs tracking-[0.35em] uppercase text-[#D4AF37]">Resources & Insights</p>
            <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-white mt-4 leading-[1.05]">
              Ideas worth your
              <span className="text-gold-gradient"> portfolio.</span>
            </h2>
          </div>
          <a
            href="#blogs"
            data-testid="blog-view-all"
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#D4AF37] hover:text-[#FFD700] transition"
          >
            <BookOpen size={16} /> View all insights
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {POSTS.map((p, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`blog-card-${i}`}
              className="group rounded-2xl overflow-hidden bg-[#111111] border border-white/8 hover:border-[#D4AF37]/40 transition-all duration-500 hover:-translate-y-1"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={p.img}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#111111] to-transparent" />
                <span className="absolute top-4 left-4 px-3 py-1 text-[10px] uppercase tracking-[0.25em] glass-strong rounded-full text-[#D4AF37]">
                  {p.cat}
                </span>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-4 text-xs text-gray-500">
                  <span>{p.date}</span>
                  <span className="flex items-center gap-1"><Clock size={12} /> {p.read}</span>
                </div>
                <h3 className="font-display font-semibold text-xl text-white mt-3 leading-snug group-hover:text-[#D4AF37] transition">
                  {p.title}
                </h3>
                <p className="text-sm text-gray-400 mt-3 leading-relaxed">{p.excerpt}</p>
                <div className="mt-5 inline-flex items-center gap-1 text-xs text-[#D4AF37] uppercase tracking-[0.25em]">
                  Read article <ArrowUpRight size={14} />
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
